import React from "react";
import {css, useTheme} from "@emotion/react";

import {PlusIcon} from "@pg-design/icons-module";
import {RowHeaderCustom} from "@pg-rp/comparison-table";

import {useComparisonToolContext} from "../../../contexts/comparison_tool_context";

export const ChangePlaceTableRowHeader = () => {
    const theme = useTheme();
    const {setChangeMyPlaceModalOpened, myPlace} = useComparisonToolContext();

    return (
        <RowHeaderCustom
            css={changePlace}
            onClick={() => {
                setChangeMyPlaceModalOpened(true);
            }}
            iconSlot={({themeDefaults}) => (
                <PlusIcon size="1.4" wrapperColor={theme.colors.primary} fill={themeDefaults.headerIcons.fill} wrapperSize={themeDefaults.headerIcons.size} />
            )}
            labelSlot={() => (myPlace ? "Zmień miejsce" : "Dodaj miejsce")}
        />
    );
};

const changePlace = css`
    display: flex;
    align-items: center;
    cursor: pointer;
`;
import React from "react";
import {css, useTheme} from "@emotion/react";

import {PlusIcon} from "@pg-design/icons-module";
import {RowHeaderCustom} from "@pg-rp/comparison-table";

import {useComparisonToolContext} from "../../../contexts/comparison_tool_context";

export const ChangePlaceTableRowHeader = () => {
    const theme = useTheme();
    const {setChangeMyPlaceModalOpened, myPlace} = useComparisonToolContext();

    return (
        <RowHeaderCustom
            css={changePlace}
            onClick={() => {
                setChangeMyPlaceModalOpened(true);
            }}
            iconSlot={({themeDefaults}) => (
                <PlusIcon size="1.4" wrapperColor={theme.colors.primary} fill={themeDefaults.headerIcons.fill} wrapperSize={themeDefaults.headerIcons.size} />
            )}
            labelSlot={() => (myPlace ? "Zmień miejsce" : "Dodaj miejsce")}
        />
    );
};

const changePlace = css`
    display: flex;
    align-items: center;
    cursor: pointer;
`;
